import React from "react";


import NavLink from "react-bootstrap/NavLink";

import NavbarBrand from "react-bootstrap/NavbarBrand";

import NavbarCollapse from "react-bootstrap/NavbarCollapse";

import NavbarToggle from "react-bootstrap/NavbarToggle";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";



import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import AuthLink from "./common/AuthLink";
import { isLoggedIn, removeAuthToken } from "../utils/auth";
import LanguageSwitcher from "./common/LanguageSwitcher";
import ThemeToggle from "./common/ThemeToggle";


function NavigationBar() {
    const { t } = useTranslation();
    return (
        <Navbar expand='lg' className="bg-primary navbar-primary w-100 fixed-top z-1" data-bs-theme='dark' >
            <Container>

                <NavbarBrand href="/" className="fs-4">KarmanTrener <span className="text-dark" >.COM.TM</span> </NavbarBrand>
                <NavbarToggle aria-controls="basic-navbar-nav" />
                <NavbarCollapse id="basic-navbar-nav">
                    <Nav className="me-auto w-100 d-flex justify-content-end ">

                        <Nav.Link as={Link} to="/#header">
                            {t("home")}
                        </Nav.Link>

                        <Nav.Link as={Link} to="/#about">

                            {t("about")}
                        </Nav.Link>

                        <Nav.Link as={Link} to="/#features">
                            {t("features")}

                        </Nav.Link>


                        {/* Payment Details Link 
                        <NavLink href="./payment">{t("subscriptions")} </NavLink>
*/}



                        <NavLink href="./privacy">{t("terms")}</NavLink>



                        <AuthLink
                            isLoggedIn={isLoggedIn()}
                            handleLogout={() => {
                                removeAuthToken();
                                window.location.href = "/";
                            }}
                        />

                        <Nav.Link as={Link} to="/#contacts">

                            {t("contact")}
                        </Nav.Link>

                    </Nav>
                    <div className="d-flex align-items-center gap-2 ms-lg-2 mt-2 mt-lg-0">
                        <LanguageSwitcher />
                        <ThemeToggle />
                    </div>

                </NavbarCollapse>


            </Container>

        </Navbar>
    )
}

export default NavigationBar;